// extracted by mini-css-extract-plugin
export default {"placeholder":"Upload_placeholder__qLgBR","wrapper":"Upload_wrapper__nQBVs"};